import express, { Router } from 'express';

import * as paymentTermValidation from '@/modules/project/paymentTerms/paymentTerms.validation';
import * as paymentTermController from '@/modules/project/paymentTerms/paymentTerms.controller';

import { validateMiddleware } from '@/shared/utils/middlewares';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router({ mergeParams: true });

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.READ),
    validateMiddleware(paymentTermValidation.getPaymentTerm),
    paymentTermController.getPaymentTerms,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.CREATE),
    validateMiddleware(paymentTermValidation.createPaymentTerm()),
    setAuditFields({ mode: AuditMode.CREATE }),
    paymentTermController.createPaymentTerm,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.READ),
    validateMiddleware(paymentTermValidation.getPaymentTermById),
    paymentTermController.getPaymentTermById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.UPDATE),
    validateMiddleware(paymentTermValidation.updatePaymentTerm()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    paymentTermController.updatePaymentTerm,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.DELETE),
    validateMiddleware(paymentTermValidation.deletePaymentTermById),
    paymentTermController.deletePaymentTermById,
  );

export default router;
